/**
 * Height helpers shared by the Ski Area Viewer page and its 3D layers. Kept
 * apart from skiArea3dLayers.js so the page can use them without loading
 * deck.gl.
 */

/**
 * The lowest known height across contours, runs and lifts, or 0. The 3D view
 * measures every height from it, so the resort sits on the map's base plane.
 */
export function baseElevation(data) {
  let min = Infinity;
  for (const f of data.contours.contours?.features || []) {
    if (f.properties.elevationM < min) min = f.properties.elevationM;
  }
  for (const fc of [data.runs, data.lifts]) {
    for (const f of fc.features) {
      for (const c of f.geometry?.coordinates || []) {
        if (c.length > 2 && Number.isFinite(c[2]) && c[2] < min) min = c[2];
      }
    }
  }
  return Number.isFinite(min) ? min : 0;
}

/** The highest known height across contours, runs and lifts, or null. */
export function topElevation(data) {
  let max = -Infinity;
  for (const f of data.contours.contours?.features || []) {
    if (f.properties.elevationM > max) max = f.properties.elevationM;
  }
  for (const fc of [data.runs, data.lifts]) {
    for (const f of fc.features) {
      for (const c of f.geometry?.coordinates || []) {
        if (c.length > 2 && Number.isFinite(c[2]) && c[2] > max) max = c[2];
      }
    }
  }
  return Number.isFinite(max) ? max : null;
}

/** Mean of a LineString's known vertex heights, or null. */
export function meanHeight(coords) {
  const zs = coords.filter(c => c.length > 2 && Number.isFinite(c[2])).map(c => c[2]);
  return zs.length ? zs.reduce((a, b) => a + b, 0) / zs.length : null;
}
